import type { Routes } from '@angular/router';
import {
    AboutUsFeature,
    createMetaResolver,
    DealerFeature,
    ngrxLoaderGuard,
    PageComponentName,
    PageContentType,
    titleResolver,
} from '@hyundai/ng-common-lib';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { AboutUsPageComponent } from './about-us-page.component';

export type AboutUsPageData = {
    isSubDealerAware: boolean;
};

export default [
    {
        path: '',
        component: AboutUsPageComponent,
        canActivate: [
            ngrxLoaderGuard({
                actionToDispatch: AboutUsFeature.actions.loadAboutUsContent(),
                waitUntilLoadedSelector: AboutUsFeature.state.selectIsLoadingAboutUsContent,
                dataToCheckSelector: AboutUsFeature.state.selectLoadedAboutUsContent,
            }),
        ],
        providers: [provideState(AboutUsFeature.state), provideEffects([AboutUsFeature.effects])],
        title: titleResolver(async (dealer, store) => {
            const isSubDealer = await firstValueFrom(store.select(DealerFeature.state.selectIsSubDealerAware));
            const subDealerOrDealer = await firstValueFrom(store.select(DealerFeature.state.selectSubDealerOrDealer));

            return isSubDealer
                ? `Ihr Hyundai Händler in ${subDealerOrDealer.city || subDealerOrDealer.street} | ${subDealerOrDealer.name}`
                : `Über Uns | ${dealer.name} ${dealer.city}`;
        }),
        resolve: {
            meta: createMetaResolver(async (store) => {
                const subDealerOrDealer = await firstValueFrom(
                    store.select(DealerFeature.state.selectSubDealerOrDealer),
                );
                return {
                    description: `Willkommen bei ${subDealerOrDealer.name}. Wir sind Ihr kompetenter Ansprechpartner für alle Fragen rund um Hyundai in ${subDealerOrDealer.city}. `,
                };
            }),
        },
        data: {
            componentName: PageComponentName.CONTACT,
            contentType: PageContentType.ABOUTUS,
        },
    },
] satisfies Routes;
